import { PageHeader } from "@/components/DashboardLayout";
import BrokerDealsTable from "@/components/BrokerDealsTable";

export default function VendorProducts() {
    return (
        <>
            <PageHeader
                eyebrow="Portfolio"
                title="My products"
                description="Products Perx has set up for your company. New products only go live once you approve them. Pricing and listing details are managed by Perx."
                testid="vendor-products-header"
            />

            <div className="px-6 lg:px-12 py-8">
                <BrokerDealsTable />
            </div>
        </>
    );
}
